import { render, staticRenderFns } from "./Pos_edit_promotion.vue?vue&type=template&id=5a431834&scoped=true&"
import script from "./Pos_edit_promotion.vue?vue&type=script&lang=js&"
export * from "./Pos_edit_promotion.vue?vue&type=script&lang=js&"
import style0 from "./Pos_edit_promotion.vue?vue&type=style&index=0&id=5a431834&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a431834",
  null
  
)

export default component.exports